import { useState } from 'react';

import { ReactComponent as TrashIcon } from 'assets/icons/trash2.svg';
import Button from 'components/common/Button/Button';
import ModalDialog from 'components/common/ModalDialog/ModalDialog';

const DeletePage = () => {
  const [open, setOpen] = useState(false);
  return (
    <span>
      <span onClick={() => setOpen(val => !val)}>
        <TrashIcon />
      </span>
      <ModalDialog
        open={open}
        onClose={() => setOpen(false)}
        title="Danger"
        actions={[
          <Button key="delte" label="Delete" />,
          <Button variant="alt" key="dont" label="Don't delete" onClick={() => setOpen(false)} />,
        ]}
      >
        <div>
          <h1>Are you sure?</h1>
          <p>You are about to delete page from review</p>
        </div>
      </ModalDialog>
    </span>
  );
};

export default DeletePage;
